import { render, staticRenderFns } from "./RolledUpJournalReportWrapper.vue?vue&type=template&id=0a29cc64&"
import script from "./RolledUpJournalReportWrapper.vue?vue&type=script&lang=ts&"
export * from "./RolledUpJournalReportWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports